import React from 'react'
import { Link } from 'react-router-dom'
import { Button, CircularProgress, TextField } from '@mui/material'
import { useAuth, useInputText } from '../../../hooks'
import { PageAlert } from '../../../components'

export default function Form() {
  const { loading, error, signUp } = useAuth()

  const initialValues = {
    email: '',
    name: '',
    password: '',
    confirmPassword: '',
  }

  const input = useInputText(initialValues)

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const { name, email, password } = input

    await signUp({ name, email, password })
  }

  return (
    <form onSubmit={handleSubmit} className="grid gap-4">
      <div className="grid gap-4 md:grid-cols-2">
        <TextField
          required
          fullWidth
          id="name"
          label="Nome completo"
          value={input.name}
          onChange={input.onChange}
          onBlur={input.onBlur}
          error={!!input.errors.name}
          helperText={input.errors.name}
          name="name"
          autoFocus
        />

        <TextField
          required
          fullWidth
          id="email"
          label="Email"
          value={input.email}
          onChange={input.onChange}
          onBlur={input.onBlur}
          error={!!input.errors.email}
          helperText={input.errors.email}
          name="email"
        />
      </div>

      <div className="grid gap-4 md:grid-cols-2">
        <TextField
          required
          fullWidth
          name="password"
          value={input.password}
          onChange={input.onChange}
          onBlur={input.onBlur}
          error={!!input.errors.password}
          helperText={input.errors.password}
          label="Palavra passe"
          type="password"
          id="password"
        />
        <TextField
          required
          fullWidth
          name="confirmPassword"
          value={input.confirmPassword}
          onChange={input.onChange}
          onBlur={input.onBlur}
          error={!!input.errors.confirmPassword}
          helperText={input.errors.confirmPassword}
          label="Repita a palavra passe"
          type="password"
          id="confirmPassword"
        />
      </div>

      {error && (
        <PageAlert
          sx={{ p: 0, mt: 2, border: 'none' }}
          severity="error"
          alertName={error}
        />
      )}

      <Button type="submit" variant="contained" disabled={loading}>
        {loading ? 'Carregando...' : 'Criar conta'}
        {loading && <CircularProgress size={24} />}
      </Button>

      <div className="grid gap-2">
        <div className="text-sm">
          Você já tem uma conta? <Link to="/login">Entrar</Link>
        </div>

        <div className="hidden">
          <Link to="#">Esqueci minha senha!</Link>
        </div>
      </div>
    </form>
  )
}
